import { MotorDriverMdl } from "./MotorDriverMdl";

export class mdlDriverAddReq{
    public PolicyNo:string;
    public RegNo:string;
    public driverListObj: Array<MotorDriverMdl> = new Array<MotorDriverMdl>();

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlDriverAddReq.ts